import { render, staticRenderFns } from "./setup.vue?vue&type=template&id=19e5bf96"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"
import style0 from "./setup.vue?vue&type=style&index=0&id=19e5bf96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports